import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { ERoles } from '@enums/roles.enum';
import { kebabCase } from 'lodash';
import { Observable } from 'rxjs';
import { IAdminUserInvitation, IInvitationCreatePayload, TAdminInvitationRole } from './admin-user-group.interface';

@Injectable({
  providedIn: 'root',
})
export class AdminInvitationsService {
  private readonly http = inject(HttpClient);

  public getInvitations(params?: HttpParams): Observable<IApiResponse<IAdminUserInvitation[]>> {
    return this.http.get<IApiResponse<IAdminUserInvitation[]>>('invitations/admin', { params });
  }

  public getInvitation(role: TAdminInvitationRole, id: string): Observable<IAdminUserInvitation> {
    return this.http.get<IAdminUserInvitation>(this.getInvitationsUrl(role, id));
  }

  public sendInvitation(
    role: TAdminInvitationRole,
    payload: IInvitationCreatePayload,
  ): Observable<IAdminUserInvitation> {
    return this.http.post<IAdminUserInvitation>(this.getInvitationsUrl(role), payload);
  }

  public revokeInvitation(role: TAdminInvitationRole, id: string): Observable<IAdminUserInvitation> {
    return this.http.delete<IAdminUserInvitation>(this.getInvitationsUrl(role, id));
  }

  private getInvitationsUrl(role: TAdminInvitationRole, id?: string): string {
    if (role === ERoles.creator) {
      return `invitations/creator${id ? `/${id}` : ''}`;
    }

    return `invitations/${kebabCase(role)}-user${id ? `/${id}` : ''}`;
  }
}
